customElements.get(`media-gallery`) || customElements.define(`media-gallery`, class extends HTMLElement {
  constructor() {
    super(), this.elements = { liveRegion: this.querySelector(`[id^="GalleryStatus"]`), viewer: this.querySelector(`[id^="GalleryViewer"]`), thumbnails: this.querySelector(`[id^="GalleryThumbnails"]`) }, this.mql = window.matchMedia(`(min-width: 750px)`), this.elements.thumbnails && (this.elements.viewer.addEventListener(`slideChanged`, debounce(this.onSlideChanged.bind(this), 500)), this.elements.thumbnails.querySelectorAll(`[data-target]`).forEach((e) => {
      e.querySelector(`button`).addEventListener(`click`, this.setActiveMedia.bind(this, e.dataset.target, false));
    }), this.dataset.desktopLayout.includes(`thumbnail`) && this.mql.matches && this.removeListSemantic());
  }
  onSlideChanged(e) {
    let t = this.elements.thumbnails.querySelector(`[data-target="${e.detail.currentElement.dataset.mediaId}"]`);
    this.setActiveThumbnail(t);
  }
  setActiveMedia(e, t) {
    var _a;
    let n = this.elements.viewer.querySelector(`[data-media-id="${e}"]`) || this.elements.viewer.querySelector(`[data-media-id]`);
    if (!n) return;
    if (this.elements.viewer.querySelectorAll(`[data-media-id]`).forEach((e2) => {
      e2.classList.remove(`is-active`);
    }), (_a = n == null ? void 0 : n.classList) == null ? void 0 : _a.add(`is-active`), t) {
      if (n.parentElement.firstChild !== n && n.parentElement.prepend(n), this.elements.thumbnails) {
        let t2 = this.elements.thumbnails.querySelector(`[data-target="${e}"]`);
        t2.parentElement.firstChild !== t2 && t2.parentElement.prepend(t2);
      }
      this.elements.viewer.slider && this.elements.viewer.resetPages();
    }
    if (this.preventStickyHeader(), window.setTimeout(() => {
      (!this.mql.matches || this.elements.thumbnails) && n.parentElement.scrollTo({ left: n.offsetLeft });
      let e2 = n.getBoundingClientRect();
      if (e2.top > -0.5) return;
      let t2 = e2.top + window.scrollY;
      window.scrollTo({ top: t2, behavior: `smooth` });
    }), this.playActiveMedia(n), !this.elements.thumbnails) return;
    let r = this.elements.thumbnails.querySelector(`[data-target="${e}"]`);
    this.setActiveThumbnail(r), this.announceLiveRegion(n, r.dataset.mediaPosition);
  }
  setActiveThumbnail(e) {
    !this.elements.thumbnails || !e || (this.elements.thumbnails.querySelectorAll(`button`).forEach((e2) => e2.removeAttribute(`aria-current`)), e.querySelector(`button`).setAttribute(`aria-current`, true), !this.elements.thumbnails.isSlideVisible(e, 10) && this.elements.thumbnails.slider.scrollTo({ left: e.offsetLeft }));
  }
  announceLiveRegion(e, t) {
    let n = e.querySelector(`.product__modal-opener--image img`);
    n && (n.onload = () => {
      this.elements.liveRegion.setAttribute(`aria-hidden`, false), this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(`[index]`, t), setTimeout(() => {
        this.elements.liveRegion.setAttribute(`aria-hidden`, true);
      }, 2e3);
    }, n.src = n.src);
  }
  playActiveMedia(e) {
    window.pauseAllMedia();
    let t = e.querySelector(`.deferred-media`);
    t && t.loadContent(false);
  }
  preventStickyHeader() {
    this.stickyHeader = this.stickyHeader || document.querySelector(`sticky-header`), this.stickyHeader && this.stickyHeader.dispatchEvent(new Event(`preventHeaderReveal`));
  }
  removeListSemantic() {
    this.elements.viewer.slider && (this.elements.viewer.slider.setAttribute(`role`, `presentation`), this.elements.viewer.sliderItems.forEach((e) => e.setAttribute(`role`, `presentation`)));
  }
});
//# sourceMappingURL=media-gallery.js.map
